"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkOIHCOMFRcjs = require('./chunk-OIHCOMFR.cjs');


var _chunkV226MHMGcjs = require('./chunk-V226MHMG.cjs');

// src/contracts/dex/v2_2/router/RouterV2_2.ts
var RouterV2_2 = (_class = class extends _chunkV226MHMGcjs.BaseRouterV2_2 {
  static __initStatic() {this.CPI = _chunkOIHCOMFRcjs.CPIRouterV2_2}
}, _class.__initStatic(), _class);



exports.RouterV2_2 = RouterV2_2;
//# sourceMappingURL=chunk-A7CW6FVU.cjs.map